export const Bio = {
  name: "Creater and Developer",
  roles: [
    "Web Developer",
    "Competetive Programmer",
    "Cloud Enthusiast",
    "Tutor",
  ],
  github: "https://github.com/27-Atul",
  linkedin: "https://www.linkedin.com/in/atul-oli27-intech/",
  twitter: "https://twitter.com/Atul_27intech",
  insta: "https://www.instagram.com/",
  linktree: "https://linktr.ee/",
};

export const skills = [
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Kotlin",
        image:
          "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
      },
      {
        name: "Jetpack Compose",
        image:
          "https://3.bp.blogspot.com/-VVp3WvJvl84/X0Vu6EjYqDI/AAAAAAAAPjU/ZOMKiUlgfg8ok8DY8Hc-ocOvGdB0z86AgCLcBGAsYHQ/s1600/jetpack%2Bcompose%2Bicon_RGB.png",
      },
      {
        name: "XML",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },

  {
    title: "Machine Learning",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Tenserflow",
        image:
          "https://static-00.iconduck.com/assets.00/tensorflow-icon-1911x2048-1m2s54vn.png",
      },
      {
        name: "Keras",
        image:
          "https://miro.medium.com/v2/resize:fit:600/1*DKu_54iqz6C-p6ndo7rO3g.png",
      },
      {
        name: "Jupyter",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1767px-Jupyter_logo.svg.png",
      },
      {
        name: "Google Colab",
        image: "https://colab.research.google.com/img/colab_favicon_256px.png",
      },
      {
        name: "Sk Learn Kit",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Scikit_learn_logo_small.svg/2560px-Scikit_learn_logo_small.svg.png",
      },
    ],
  },
  {
    title: "DevOps",
    skills: [
      {
        name: "AWS",
        image:
          "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
      },
      {
        name: "Azure",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/a/a8/Microsoft_Azure_Logo.svg",
      },
      {
        name: "Google Cloud",
        image:
          "https://static-00.iconduck.com/assets.00/google-cloud-platform-logo-icon-2048x1824-pg4wzspq.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Kubernetes",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/0/00/Kubernetes_%28container_engine%29.png",
      },
    ],
  },
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Canva",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/Canva_logo_%282021%29.svg/1024px-Canva_logo_%282021%29.svg.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Spring",
        image: "https://www.vectorlogo.zone/logos/springio/springio-icon.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Flask",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Flask_logo.svg/1280px-Flask_logo.svg.png",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },

      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },

  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://zenprospect-production.s3.amazonaws.com/uploads/pictures/659842167fbaa70001cc6386/picture",
    role: "Learner and Mentor",
    company: "TBI GEU",
    date: "Jan 2024 - Jan 2025",
    desc: "Gained hands-on experience with in frontend Development, API development, Dynmanic Data sharing.",
    skills: ["React", "NodeJS", "ExpressJS", "MongoDB"],
    doc: "",
  },
  
  // {
  //   id: 1,
  //   img: "https://upload.wikimedia.org/wikipedia/en/thumb/6/6f/Indian_Institute_of_Technology_Roorkee_logo.png/512px-Indian_Institute_of_Technology_Roorkee_logo.png",
  //   role: "",
  //   company: "Cybersprint Hackathon IIT Roorkee 2023",
  //   date: "Mar 13 2023",
  //   desc: "48 hour hackathon organised by Indian Institute of Technology Roorkee Uttarakhand. Developed a dynamic and interactive payment web app for FAMPAY to boost its use on college campuses. Leverage the power of Three.js and Three.js Fiber to seamlessly import interactive, visually stunning 3D objects into our project. Developed a vibrant community forum where members can stay in the loop and build meaningful connections.",
  //   skills: [
  //     "HTML",
  //     "CSS",
  //     "React Js",
  //     "Three Js",
  //     "Php",
  //     "Netlify",
  //     "JavaScript",
  //   ],
  //   //doc: "https://private-user-images.githubusercontent.com/111555189/303749494-11d40b8c-a5ff-4778-ad54-8eb4f19e7b20.png?jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJnaXRodWIuY29tIiwiYXVkIjoicmF3LmdpdGh1YnVzZXJjb250ZW50LmNvbSIsImtleSI6ImtleTUiLCJleHAiOjE3MDc1MDU0MTcsIm5iZiI6MTcwNzUwNTExNywicGF0aCI6Ii8xMTE1NTUxODkvMzAzNzQ5NDk0LTExZDQwYjhjLWE1ZmYtNDc3OC1hZDU0LThlYjRmMTllN2IyMC5wbmc_WC1BbXotQWxnb3JpdGhtPUFXUzQtSE1BQy1TSEEyNTYmWC1BbXotQ3JlZGVudGlhbD1BS0lBVkNPRFlMU0E1M1BRSzRaQSUyRjIwMjQwMjA5JTJGdXMtZWFzdC0xJTJGczMlMkZhd3M0X3JlcXVlc3QmWC1BbXotRGF0ZT0yMDI0MDIwOVQxODU4MzdaJlgtQW16LUV4cGlyZXM9MzAwJlgtQW16LVNpZ25hdHVyZT02YmVmMTlmMGU0ZDc2ZmVkMDkwNTAxZWM4NWU2NTg0MmM3NzQwYjk5NDJmNzRmMDljMzM0YmJkMWQ5OGE2ZWNjJlgtQW16LVNpZ25lZEhlYWRlcnM9aG9zdCZhY3Rvcl9pZD0wJmtleV9pZD0wJnJlcG9faWQ9MCJ9.V7A07wzP6i2TZ9ShBWl01ObVofXT5JmsOifYdp5-p2Q",
  // },
];

export const education = [
  {
    id: 0,
    img: "http://www.namastedehradun.com/wp-content/uploads/2016/06/Graphic_Era_Hill_University_Logo-300x300.png",
    school: "Graphic Era Hill University, Bhimtal ",
    date: "Oct 2022 - July 2025",
    grade: "8.1 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Application from Graphic Era Hill University, Bhimtal. I have complete have a CGPA of 8.1. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the Google Developers Student Club (GDSC) at KIIT, where I am learning and working on exciting projects with a team of talented developers.",
    degree: "Bachelor of COmputer Application",
  },
  {
    id: 1,
    img: "https://www.apscnr.com/img/army-public-school-logo.png",
    school: "Army Public School , Pithoragarh",
    date: "Apr 2021 - Apr 2022",
    grade: "Grade A",
    desc: "I completed my class 12 high school  where I studied Commerce with Math Knowledge of finance and math in business field.",
    degree: "CBSE(XII), Commerce with Maths",
  },
  {
    id: 2,
    img: "https://www.apscnr.com/img/army-public-school-logo.png",
    school: "Army Public School , Pithoragarh",
    date: "Apr 2019 - Apr 2020",
    grade: "73.5%",
    desc: "I completed my class 10 education where I studied Pysics, Chemistry, Maths, Computer Science",
    degree: "CBSE(X), Science with Computer",
  },
];

export const projects = [
  {
    id: 11,
    title: "ELearning Management System-AI",
    date: "August 2024 - April 2025",
    description:
      "Developed a real-time Course watch and course create application with real-time updates. Implemented filtering options and search functionality for customizedexploration. Has a user-friendly bookmarking feature, allowing users to save articles",
    image:
      "https://github.com/27-Atul-PahadiCoder/Personal_Portfolio/blob/main/images/p1.png?raw=true",
    tags: ["ReactJS", "NodeJS", "ExpressJS", "MongoDB / SQL"],
    category: "android app",
    github: "https://github.com/Atuloli01/E-learning-Sharing-MS",
    webapp: "https://github.com/Atuloli01/E-learning-Sharing-MS",
  },
  {
    id: 9,
    title: "Real TIme Attendance Management System-AWS",
    date: "October 2023 - April 2024",
    description:
      "WEB Application for Image & Text Detection & Sound Recognition.Integrated real-time image classification, audio processing & text analysis offering instant feedback using Machine Learning models. Used Google CodeLabs for making Machine Learning Models",
    image:
      "https://github.com/27-Atul-PahadiCoder/Personal_Portfolio/blob/main/images/p2.png?raw=true",
    tags: ["ReactJS","Python ", "API management", "AWS"],
    category: "machine learning",
    github: "https://github.com/27-Atul-PahadiCoder/Smart-Attendance-System",
    webapp: "https://github.com/27-Atul-PahadiCoder/Smart-Attendance-System",
  },
  {
    id: 0,
    title: "DevBhoomi Tourism Website",
    date: "Apr 2024 - Present",
    description:
      "Developed a full-stack web application that allows users to search for, play, and pause their favorite podcasts on demand and create podcasts. Implemented user authentication using Google Auth and Jwt Auth, made responsive user interface with React JS that provides users with a seamless experience across all devices. Practiced agile methodologies to optimize team efficiency and communication.",
    image:
      "https://github.com/27-Atul-PahadiCoder/Personal_Portfolio/blob/main/images/p3.png?raw=true",
    tags: ["HTML", "CSS", "JavaScript", "MongoDb", "Node Js"],
    category: "web app",
    github: "https://github.com/abhayjoshi201/DevBhoomi-Tourism",
    webapp:
      "https://651affdc84c9d51cee1e83b5--dreamy-marzipan-2eabcf.netlify.app/",
    member: [
      {
        name: "Atul Oli",
        img: "https://avatars.githubusercontent.com/u/125664476?s=96&v=4",
        linkedin: "https://www.linkedin.com/in/atul-oli27-intech/",
        github: "https://github.com/Atuloli01",
      },
      {
        name: "Atul Oli",
        img: "https://avatars.githubusercontent.com/u/125664476?s=96&v=4",
        linkedin: "https://www.linkedin.com/in/atul-oli27-intech/",
        github: "https://github.com/Atuloli01",
      },
      {
        name: "Atul Oli",
        img: "https://avatars.githubusercontent.com/u/125664476?s=96&v=4",
        linkedin: "https://www.linkedin.com/in/atul-oli27-intech/",
        github: "https://github.com/Atuloli01",
      },
      {
        name: "Atul Oli",
        img: "https://avatars.githubusercontent.com/u/125664476?s=96&v=4",
        linkedin: "https://www.linkedin.com/in/atul-oli27-intech/",
        github: "https://github.com/Atuloli01",
      },
    ],
  },
  {
    id: 1,
    title: "Agents Development",
    date: "May 2025 - Present",
    description:
      "Designed and developed a Agentic SAAS product, A simple & elegant web app for the Automatic tasks.",
    image:
      "https://user-images.githubusercontent.com/64485885/234916413-96296f13-fe4b-4cc4-b215-e72bd7c27928.png",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "THREE.JS",
      "MYSQL",
      "PHP",
    ],
    category: "web app",
    github: "https://github.com/abhayjoshi201/fampayClone",
    webapp: "https://fampay-clone.netlify.app/",
    member: [
      {
        name: "Atul Oli",
        img: "https://avatars.githubusercontent.com/u/125664476?s=96&v=4",
        linkedin: "https://www.linkedin.com/in/atul-oli27-intech/",
        github: "https://github.com/Atuloli01",
      },
      {
        name: "Atul Oli",
        img: "https://avatars.githubusercontent.com/u/125664476?s=96&v=4",
        linkedin: "https://www.linkedin.com/in/atul-oli27-intech/",
        github: "https://github.com/Atuloli01",
      },
      {
        name: "Atul Oli",
        img: "https://avatars.githubusercontent.com/u/125664476?s=96&v=4",
        linkedin: "https://www.linkedin.com/in/atul-oli27-intech/",
        github: "https://github.com/Atuloli01",
      },
      {
        name: "Atul Oli",
        img: "https://avatars.githubusercontent.com/u/125664476?s=96&v=4",
        linkedin: "https://www.linkedin.com/in/atul-oli27-intech/",
        github: "https://github.com/Atuloli01",
      },
    ],
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
